import React, { Fragment, useState } from 'react'
import { Avatar, Button, makeStyles, Paper, TextField, Typography } from '@material-ui/core';
import LockOpenOutlinedIcon from '@material-ui/icons/LockOpenOutlined'
import { DoneOutlined } from '@material-ui/icons';
import Parse from 'parse';

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: theme.spacing(2, 8, 5, 8)
    },
    avatar: {
        margin: theme.spacing(2),
        backgroundColor: theme.palette.secondary.main,
    },
    submit: {
        margin: theme.spacing(3, 0, 0, 0),

    }
}));

const RecoverPassword = ({ setNavRecoverPassword }) => {

    const classes = useStyles()

    const [inputText, setInputText] = useState('')
    const [confirmResetPassword, setConfirmResetPassword] = useState(false)
    const [errors, setErrors] = useState({ notAccount: false, notInput: false, notEmail: false })

    const validateForm = async () => {

        let validForm = true;
        const formErrors = { notAccount: false, notInput: false, notEmail: false };

        if (inputText) {

            const byKey = new Parse.Query("RegisteredCustomers");
            byKey.equalTo('k', inputText).equalTo('envId', localStorage.env).doesNotExist('deletedAt')

            const byEmail = new Parse.Query("RegisteredCustomers");
            byEmail.equalTo('e', inputText).equalTo('envId', localStorage.env).doesNotExist('deletedAt')

            const mainQuery = Parse.Query.or(byKey, byEmail);

            const result = await mainQuery.first();

            if (result) {

                if (!result.get('e')) {
                    formErrors.notEmail = true
                    validForm = false;
                    setErrors(formErrors);
                    return validForm;
                }
                // Generamos nueva contraseña aleatoria y la modificamos en el usaurio

                let chars = "0123456789abcdefghijklmnopqrstuvwxyz";
                let passwordLength = 6;
                let password = "";

                for (let i = 0; i <= passwordLength; i++) {
                    let randomNumber = Math.floor(Math.random() * chars.length);
                    password += chars.substring(randomNumber, randomNumber + 1);
                }

                result.set('p', password)
                result.set('sp', false)
                await result.save()


                // Enviamos el mail con la nueva contraseña al usuario

                const requestOptions = {
                    method: 'POST',
                    redirect: 'follow'
                };

                fetch(`http://164.90.134.205:61400/restorePassword?to=${result.get('e')}&newPass=${password}&from=RAZ Y CIA SA`, requestOptions)
                    .then(response => response.text())
                    .then(result => { })
                    .catch(error => console.log('error', error));


            } else {
                formErrors.notAccount = true
                validForm = false;
            }

        } else {
            formErrors.notInput = true
            validForm = false;
        }
        setErrors(formErrors);
        return validForm;
    }

    const handleSubmit = async () => {

        const validForm = await validateForm();

        if (!validForm) return;
    
        setConfirmResetPassword(true)
    };

    return (
        <Fragment>
            {
                confirmResetPassword ?
                    <Paper elevation={1} className={classes.paper}>
                        <Avatar className={classes.avatar}>
                            <DoneOutlined />
                        </Avatar>
                        <Typography component="h1" variant="h5">
                            La ayuda está en camino
                        </Typography>
                        <Typography style={{ margin: '15px 0px' }} component="p" variant="body2">
                            Recibirás un correo electrónico con más instrucciones. Si no tienes
                            noticias nuestras en los próximos 15 minutos,
                            verifica que hayas escrito la dirección de correo
                            electrónico correcta y revisa tu carpeta de spam.
                        </Typography>
                        <Button
                            fullWidth
                            variant="text"
                            color="secondary"
                            onClick={() => { setNavRecoverPassword(false) }}
                            className={classes.submit}
                        >
                            Volver al login
                        </Button>
                    </Paper>
                    :
                    <Paper elevation={1} className={classes.paper}>
                        <Avatar className={classes.avatar}>
                            <LockOpenOutlinedIcon />
                        </Avatar>
                        <Typography component="h1" variant="h5">
                            Restablece tu contraseña
                        </Typography>
                        <Typography style={{ margin: '15px 0px' }} component="p" variant="body2">
                            Introduce el código de cliente o la dirección de correo electrónico en la que recibiras la información para restablecer la contraseña.
                        </Typography>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            label="Código de cliente o Email"
                            autoComplete="email"
                            value={inputText}
                            onChange={(e) => setInputText(e.target.value)}
                            error={errors.notAccount || errors.notInput}
                            helperText={errors.notAccount ? "No existe un usuario con esta información" : errors.notInput ? "Debes completar la información solicitada" : errors.notEmail ? "La cuenta no tiene un mail registrado" : ""}
                            autoFocus
                        />
                        <Button
                            fullWidth
                            variant="contained"
                            color="secondary"
                            onClick={() => { handleSubmit() }}
                            className={classes.submit}
                        >
                            Ingresar
                        </Button>
                        <Button
                            fullWidth
                            variant="text"
                            color="secondary"
                            onClick={() => { setNavRecoverPassword(false) }}
                            className={classes.submit}
                        >
                            Volver al login
                        </Button>
                    </Paper>
            }
        </Fragment>
    )
}

export default RecoverPassword